import serverData from 'ppbl/utils/server-data'

function useExperiments() {
  const { experiments } = serverData
  return experiments
}

export default useExperiments
